import styled from 'styled-components/native';

export const Row = styled.View`
  flex-direction: row;
`;

export const InactiveArea = styled.View<{ score: number }>`
  background-color: ${({ theme }) => theme.colors.placeholder};
  width: ${({ score }) => score}%;
`;

export const ActiveArea = styled.View<{
  size: number;
  score: number;
  color?: string;
}>`
  background-color: ${({ theme, color }) => color ?? theme.colors.primary};
  height: ${({ size }) => size}px;
  width: ${({ score }) => score}%;
`;
